import { Stack, Typography } from "@mui/material";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

const EmptyTrace = ({ isTrace = false }: { isTrace?: boolean }) => {
    return (
        <Stack sx={isTrace ? { direction: "column", alignItems: "center", py: 5 } : { direction: "column", alignItems: "center", justifyContent: "center", spacing: 2, width: "100vw", height: "calc(var(--app-vh, 1vh) * 100)" }}>
            <ErrorOutlineIcon color="error" sx={{ fontSize: isTrace ? 50 : 60 }} />
            <Typography variant="h6" sx={{ color: '#000000', textAlign: 'center' }}>
                We couldn't find your trace. Please try again.
            </Typography>
        </Stack>
    )
}

export default EmptyTrace;